import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { IconAlertTriangleFilled } from '@calendly/ui/components/glyphs/IconAlertTriangleFilled';
import { Link } from '@calendly/ui/components/link';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1xfveb";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const warningLineCss = "w1j1fwk1";
const WarningLine = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(warningLineCss, props.className)} />;
});
const collectiveWarningContainerCss = "cv0051z";
const CollectiveWarningContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(collectiveWarningContainerCss, props.className)} />;
});
const ScheduledEventsLink = ({
  children
}) => <Link underline={false} href="/app/scheduled_events/user/me">{children}</Link>;
const CoHostsUnavailableWarning = ({
  membersWithConflicts,
  isTopSpot = false
}) => {
  const cohostHasConflict = !!membersWithConflicts?.length;
  if (!cohostHasConflict) return null;
  if (isTopSpot) {
    return <Container>
        {I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.collective.hosts_are_unavailable', {
        names: membersWithConflicts.join(', ')
      })}
      </Container>;
  }
  return <Container>
      <CollectiveWarningContainer>
        <WarningLine>
          {I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.collective.hosts_are_unavailable', {
          names: membersWithConflicts.join(', ')
        })}
        </WarningLine>
        <WarningLine>
          {I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.collective.cancel_or_reschedule')}
        </WarningLine>
      </CollectiveWarningContainer>
    </Container>;
};
const UnavailableWarning = ({
  availabilityCode,
  isTopSpot = false,
  allowBooking,
  cohostHasConflict
}) => {
  const getContent = () => {
    switch (availabilityCode) {
      case 'buffer':
        return isTopSpot ? I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.buffer.short') : HtmlParser(I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.buffer.long'), {
          ScheduledEventsLink
        });
      case 'internal':
        return isTopSpot ? I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.internal.short') : HtmlParser(I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.internal.long'), {
          ScheduledEventsLink
        });
      case 'reserved':
        return isTopSpot ? I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.reserved.short') : I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.reserved.long');
      default:
        return null;
    }
  };
  if (allowBooking) {
    if (availabilityCode && !cohostHasConflict) {
      return <Container data-testid="unavailable-warning">
          <UiIcon icon={IconAlertTriangleFilled} size="small" color={colorTextDestructive} />
          {' '}
          {I18n.t('publisher.scheduled_events.pending.poll_results.unavailable_warning.unavailable')}
        </Container>;
    }
    return null;
  }
  return <Container data-testid="unavailable-warning">
      {getContent()}
    </Container>;
};
const expiredNoticeCss = "e13sic0g";
const ExpiredNotice = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(expiredNoticeCss, props.className)}>
      {I18n.t('publisher.scheduled_events.pending.poll_results.spot_in_past')}
    </Component>;
});
export const WarningsSection = ({
  isSpotExpired,
  isPollActive,
  allowSpotBooking,
  isTopSpot,
  spot,
  cohostHasConflict
}) => {
  if (!isPollActive) return null;
  if (isSpotExpired) return <ExpiredNotice />;
  return <>
      <UnavailableWarning availabilityCode={spot.availabilityCode} isTopSpot={isTopSpot} allowBooking={allowSpotBooking} cohostHasConflict={cohostHasConflict} />
      <CoHostsUnavailableWarning membersWithConflicts={spot.membersWithConflicts} isTopSpot={isTopSpot} />
    </>;
};

require("./warnings.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./warnings.js");